import {Component, forwardRef, OnInit} from '@angular/core';
import { NG_VALUE_ACCESSOR, Validators, FormGroup, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  compareMatch,
  DscrIndustry,
  DscrIndustrySelectionValue,
  DscrIndustrySelectionValueOptions,
} from '@portal-workspace/grow-shared-library';
import {distinctUntilChanged, tap} from 'rxjs/operators';
import {DscrIndustrySelectionModuleService} from './dscr-industry-selection-module.service';
import {AbstractControlValueAccessor} from '../abstract-control-value-accessor';
import {UntilDestroy} from '@ngneat/until-destroy';
import {Subscription} from 'rxjs';
import {formControlErrorKeys, formControlErrorMessage, setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {MARK, Mark} from '@portal-workspace/grow-ui-library/mark';
import { MatOptionModule } from '@angular/material/core';

import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';


@UntilDestroy()
@Component({
    selector: 'dscr-industry-selection',
    templateUrl: './dscr-industry-selection.component.html',
    styleUrls: ['./dscr-industry-selection.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DscrIndustrySelectionComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => DscrIndustrySelectionComponent) },
    ],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatOptionModule]
})
export class DscrIndustrySelectionComponent extends AbstractControlValueAccessor<DscrIndustry> implements OnInit, Mark {

  formGroup: FormGroup<{
    select: FormControl<DscrIndustry | null>;
  }>;
  formControl: FormControl<DscrIndustry | null>;

  dscrIndustries: DscrIndustry[] = DscrIndustrySelectionValueOptions;
  subscription?: Subscription;
  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;

  compareWithFn: (option: DscrIndustrySelectionValue, selected: DscrIndustrySelectionValue) => boolean = (option, selected) => {
    return (!!option && !!selected && option.name === selected.name);
  };

  constructor(private formBuilder: FormBuilder,
              private service: DscrIndustrySelectionModuleService) {
    super();
    this.formControl = formBuilder.control(null, [Validators.required]);
    this.formGroup = formBuilder.group({
      select: this.formControl,
    });
    this.subscription = this.formControl.valueChanges.pipe(
      distinctUntilChanged(compareMatch),
      tap(r => {
        this.service.setDscrIndustry(r ? r : null);
        this.propagateChange(r);
      })
    ).subscribe();
  }

  ngOnInit(): void {
    setupUntilDestroy(this);
  }

  doWriteValue(v?: DscrIndustry): void | DscrIndustry {
    if (v) {
      const op = DscrIndustrySelectionValueOptions.find(opt => opt.name === v.name);
      if (op) {
        this.formControl.setValue(op);
        return op;
      }
    }
    return undefined;
  }
  mark() {
    this.formGroup.markAllAsTouched();
  }
}
